import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { usePackageDisplayName_package$key } from "./__generated__/usePackageDisplayName_package.graphql";

export const usePackageDisplayName = (
  packageRef?: usePackageDisplayName_package$key | null
) => {
  const pkg = useFragment(usePackageDisplayNameFragmentString, packageRef);
  return pkg?.displayInApp?.displayName ?? pkg?.name ?? "";
};

const usePackageDisplayNameFragmentString = graphql`
  fragment usePackageDisplayName_package on Package {
    displayInApp {
      displayName
    }
    name
  }
`;
